import React, { useContext } from "react";

import { Link } from "react-router-dom";

import { Flex, Box, Spacer, Heading, Img } from "@chakra-ui/react";

import { forward, back, play, circBack } from "../../assets";

import { Breakpoints } from "../../context";

export const Nav = ({ title, home, fontsPage }) => {
  const size = useContext(Breakpoints);

  return (
    <nav>
      <Flex mb={{ base: "16px", md: "24px", lg: "24px" }} align="center">
        <Flex align="baseline">
          <Box>
            <Heading
              fontFamily="'Ubuntu', sans-serif"
              fontWeight="medium"
              fontSize={{ base: "24px", md: "28px", lg: "40px" }}
              lineHeight={{ base: "28px", md: "32px", lg: "40px" }}
              mr="5px"
              color="#131215"
            >
              {title}
            </Heading>
          </Box>
          <Box alignSelf="flex-end">
            <Img
              boxSize={{ base: "22px", md: "30px", lg: "30px" }}
              src={play}
              alt="o"
            />
            {/* <img
              src={play}
              width="30px"
              height="30px"
              alt="Youtube Tutorial Button"
            /> */}
          </Box>
        </Flex>

        <Spacer />
        <Box pr="24px">
          {size === "mobile" ? (
            ""
          ) : (
            <Flex align="center">
              {home ? (
                <Link to="/font">
                  <img src={forward} alt="FElCO LOGO" />
                </Link>
              ) : fontsPage ? (
                <>
                  <Link to="/" style={{ marginRight: "12px" }}>
                    <img src={back} alt="FElCO LOGO" />
                  </Link>
                  <Link to="/color-palette">
                    <img src={forward} alt="FElCO LOGO" />
                  </Link>
                </>
              ) : (
                <>
                  <Link to="/font" style={{ marginRight: "12px" }}>
                    <img src={circBack} alt="FElCO LOGO" />
                  </Link>
                </>
              )}
            </Flex>
          )}
        </Box>
      </Flex>
    </nav>
  );
};
